import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { PropType } from "vue";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import isBetween from "dayjs/plugin/isBetween";
import { IBookableDatesInfo, IDateInfo } from "@/domain/entities/book";
import { computed } from "@vue/reactivity";


const __default__ = {
  name: "MonthlyBookCalendarWithDuplicatedSeat",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  bookableDatesInfo: {
    type: Object as PropType<IBookableDatesInfo>,
    required: true,
  },
  selectedDateInfo: {
    type: Object as PropType<IDateInfo>,
  },
  seatsSelectable: {
    type: Boolean,
    default: false,
  },
  isMonthlyBook: {
    type: Boolean,
    default: false,
  },
  allowWaitList: {
    type: Boolean,
    default: false,
  },
},
  emits: ["onClickDay", "onClickDayForWaiting", "onUpdateBookingDate", "onRemoveBookingDate"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

_useCssVars(_ctx => ({
  "7e187fcd-bookableDayOfWeekCount": (_unref(bookableDayOfWeekCount)),
  "7e187fcd-gridStartIndex": (gridStartIndex)
}))

const props = __props;

const emit = __emit;

dayjs.locale("ko");
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isBetween);
dayjs.tz.setDefault("Asia/Seoul");

const calendarTitle =
  props.bookableDatesInfo.bookableMonth.replace("-", "년 ") + "월";

const isBookableSeat = (dateInfo: IDateInfo) => {
  return dateInfo.bookableDate?.targetSeatBookableYn;
};

const isBookableDate = (dateInfo: IDateInfo) => {
  return (
    !!dateInfo.bookableDate && dateInfo.bookableDate.myBookableSeatsCount > 0
  );
};

const isSelectedDate = (dateInfo: IDateInfo) => {
  return props.selectedDateInfo?.date === dateInfo.date;
};

const isFullyBooked = (dateInfo: IDateInfo) => {
  return (
    !!dateInfo.bookableDate &&
    (dateInfo.bookableDate?.remainingSeatsCount ?? 0) <= 0
  );
};

const findBookableDate = (date: string) => {
  return props.bookableDatesInfo.bookableDates.find(
    (bookableDate) => bookableDate.date === date
  );
};

const hasBookableDateOnDayOfWeek = (dayOfWeekIndex: number) => {
  return props.bookableDatesInfo.bookableDates.some(
    (bookableDate) => dayjs(bookableDate.date).day() === dayOfWeekIndex
  );
};
const bookableOnSaturday = hasBookableDateOnDayOfWeek(6);
const bookableOnSunday = hasBookableDateOnDayOfWeek(0);
const bookableDayOfWeekCount = computed(
  () => 5 + (bookableOnSaturday ? 1 : 0) + (bookableOnSunday ? 1 : 0)
);

const year = Number(props.bookableDatesInfo.bookableMonth.split("-")[0]);
// "2022-08" -> 7 (1월: 0부터 시작)
const month = Number(props.bookableDatesInfo.bookableMonth.split("-")[1]) - 1;

const firstDate = dayjs(new Date(year, month, 1));
const daysInMonth = firstDate.daysInMonth();
const dateInfos: IDateInfo[] = [];

for (let i = 1; i <= daysInMonth; i++) {
  const dayJs = dayjs(new Date(year, month, i));
  const dayOfWeek = dayJs.day();

  if (!bookableOnSunday && dayOfWeek === 0) continue;
  if (!bookableOnSaturday && dayOfWeek === 6) continue;

  const date = dayJs.format("YYYY-MM-DD");
  const dateInfo: IDateInfo = {
    dayJs: dayJs,
    date: date,
    bookableDate: findBookableDate(date),
  };
  dateInfos.push(dateInfo);
}

const gridStartIndex = dateInfos[0].dayJs.day() + (bookableOnSunday ? 1 : 0);

const onClickDay = (dateInfo: IDateInfo, target: EventTarget | null) => {
  if (isFullyBooked(dateInfo) && props.allowWaitList) {
    emit("onClickDayForWaiting", dateInfo, target);
    return;
  }

  if (
    !isBookableDate(dateInfo) ||
    isBookableSeat(dateInfo) ||
    isFullyBooked(dateInfo)
  )
    return;

  emit("onClickDay", dateInfo, target);
};

const __returned__ = { props, emit, calendarTitle, isBookableSeat, isBookableDate, isSelectedDate, isFullyBooked, findBookableDate, hasBookableDateOnDayOfWeek, bookableOnSaturday, bookableOnSunday, bookableDayOfWeekCount, year, month, firstDate, daysInMonth, dateInfos, gridStartIndex, onClickDay }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})